import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  dashedBorder: {
    border: "1px dashed",
    borderColor: theme.palette.primary.main,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  text: {
    marginBottom: theme.spacing(2),
  },
  movieDetailContainer: {
    marginTop: theme.spacing(2),
    marginLeft: "6%",
    marginRight: "6%",
    paddingBottom: theme.spacing(4),
  },
  movieDescriptionContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(0.5),
    },
  },
  playerContainer: {
    marginTop: theme.spacing(1),
    width: "100%",
    backgroundColor: "black",
  },
  player: {
    flex: 1,
    margin: "auto",
  },
  geoContainer: {
    ...theme.typography.subtitle1,
    color: "#ffffff",
    width: "100%",
    paddingTop: "56.52%",
    position: "relative",
  },
  textCenter: {
    margin: 0,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
  },
}));
